export class MenuDropdownItem {
  public id!: string;
  public label!: string;
  public subLabel!: string;

  constructor(item: IMenuDropdownItem | null) {
    if (item) {
      this.id = item.id;
      this.label = item.label;
      this.subLabel = item.subLabel;
    }
  }
}

export interface IMenuDropdownItem {
  id: string;
  label: string;
  subLabel: string;
}
